import React from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck, FileSignature, ArrowRight, CheckCircle2, Activity } from "lucide-react";
import { HomePanel, PanelEmpty } from "./HomePanel";
import { Button } from "@/portal/ui/Button";
import { Avatar } from "@/portal/ui/Layout";
import { DECISION_KIND } from "@/portal/ui/Badge";
import { fmtDateHuman, timeAgo } from "@/portal/format";

/** „Task-uri care necesită aprobarea ta” — deciziile în așteptare. */
export function TasksCard({ decisions }) {
  const list = (decisions || []).slice(0, 3);
  return (
    <HomePanel icon={ClipboardCheck} title="Task-uri care necesită aprobarea ta" to="/portal/decizii" testid="home-tasks">
      {list.length === 0 ? <PanelEmpty icon={CheckCircle2} tone="success" text="Nicio aprobare în așteptare. Toate solicitările au fost soluționate." /> : (
        <ul className="space-y-3 mt-0.5" data-testid="home-tasks-list">
          {list.map((a) => (
            <li key={a.id} className="flex items-center gap-3" data-testid={`home-task-${a.id}`}>
              <span className="cp-tile is-sm is-amber"><FileSignature /></span>
              <div className="flex-1 min-w-0">
                <div className="text-[13.5px] font-semibold text-cp-text leading-snug truncate">{a.title}</div>
                <div className="cp-meta truncate">{DECISION_KIND[a.kind] || "Solicitare"} · {a.deadline ? `termen ${fmtDateHuman(a.deadline)}` : fmtDateHuman(a.created_at)}</div>
              </div>
              <Button as={Link} to={`/portal/decizii?id=${a.id}`} size="sm" className="shrink-0" data-testid={`home-task-open-${a.id}`}>Analizează <ArrowRight /></Button>
            </li>
          ))}
        </ul>
      )}
    </HomePanel>
  );
}

/** „Activitate recentă” — jurnal unificat (actualizări, documente, poze, decizii, ședințe, riscuri). */
export function ActivityCard({ activity, project }) {
  const list = (activity || []).slice(0, 4);
  const pid = project?.id || list[0]?.project_id;
  return (
    <HomePanel icon={Activity} title="Activitate recentă" to={pid ? `/portal/proiecte/${pid}?tab=jurnal` : undefined} testid="home-activity">
      {list.length === 0 ? <PanelEmpty icon={Activity} text="Activitatea echipei va apărea aici." /> : (
        <ul className="space-y-3 mt-0.5" data-testid="home-activity-list">
          {list.map((e) => (
            <li key={e.id} className="flex items-start gap-3" data-testid="home-activity-item">
              <Avatar name={e.actor} size="sm" />
              <div className="flex-1 min-w-0">
                <p className="text-[13px] text-cp-text-2 leading-snug"><span className="font-semibold text-cp-text">{e.actor}</span> {e.text}</p>
                <Link to={`/portal/proiecte/${e.project_id}?tab=${e.tab}`} className="cp-meta hover:text-cp-accent transition-colors">{timeAgo(e.at)} · {e.project_name}</Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </HomePanel>
  );
}
